import { Label as MatchboxLabel } from '@sparkpost/matchbox';

/**
 * Matchbox Label component
 * @see https://design.sparkpost.com/components/label/
 */
const Label = MatchboxLabel;

export default Label;
